<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		.flow-left
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
				div
					v-form(@submit.native.prevent="search()")
						v-text-field.mb-4(v-model="searchterm" append-icon="search" placeholder="Zoeken" outlined)
					div.mb-4(v-for="item in google")
						a(:href="item.link")
							h2.subtitle-1.font-weight-bold.mb-0 {{item.title}}
						a.accent--text(:href="item.link" v-html="item.htmlFormattedUrl")
						p(v-if="item.htmlSnippet" v-html="item.htmlSnippet.replace('<br>', '')")
				div(slot="sidebar")
					ad(location="sidebar").mb-6
					offers
</template>

<script>
import gql from 'graphql-tag';
import NavigationDefault from '@/components/navigation-default';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import { interpolateFields } from '@/utils/interpolate.js';

const contentpageQuery = gql`
	query getGoogleSearch($slug: String!) {
		contentpage(slug: $slug) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
	}
	${MetaFragment}
`;

const searchQuery = gql`
	query getGoogleSearch($term: String!, $limit: Int!) {
		google(term: $term, limit: $limit) {
			title
			link
			htmlFormattedUrl
			htmlSnippet
		}
	}
`;

export default {
	name: 'Search',
	watchQuery: ['q'],
	nuxtI18n: {
		paths: {
			'nl-NL': '/zoeken',
			'de-DE': '/suchen',
			'nl-BE': '/zoeken'
		}
	},
	components: { NavigationDefault },

	async asyncData({ _params, app, route }) {
		const contentpage = await app.$graphClient
			.query({
				query: contentpageQuery,
				variables: {
					slug: route.path.split('/').pop()
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) throw errors[0];

				const interpolater = interpolateFields({
					find: /{term}/gi,
					replace: route.query.q ? route.query.q : ''
				});
				interpolater(data.contentpage.meta, ['title', 'description']);
				interpolater(data.contentpage.content, ['markdown']);
				interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[data.contentpage.name]: { name: 'search' }
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'search-01', error);
			});

		if (!route.query.q) return { ...contentpage, google: [] };

		const search = await app.$graphClient
			.query({
				query: searchQuery,
				variables: {
					term: route.query.q,
					limit: 10
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) throw errors[0];

				data.searchterm = route.query.q;
				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'search-02', error);
			});

		return { ...contentpage, ...search };
	},
	data: () => ({
		searchterm: ''
	}),
	methods: {
		search() {
			this.$router.push(
				this.localePath({
					name: 'search',
					query: { q: this.searchterm }
				})
			);
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
